<template>
    <div class="table-responsive rounded w-full px-2 remove-overflow-x overflow-auto">
        <div v-if="inline_update_loading || pin_project_loading" class="text-5xl text-grey-darkest text-center mt-32 inline_update_loading_class">
            <i class="fa fa-spin fa-spinner" aria-hidden="true"></i>
        </div>
        <table class="text-left w-full border-collapse table-bordered" :style="inline_update_loading || pin_project_loading ? 'opacity:0.3' : ''" id="followupProjects">
            <thead>
            <tr>
                <th :colspan="availableColumns.length" class="text-center bg-teal text-white">
                    Follow Up
                </th>
                <td class="text-right bg-teal text-white col-md-2">
                    <div class="col-sm-3 float-right">
                        <dashboard-export-icon
                            name="Follow Up"
                            :projects="followUps.projects"
                            :state="columns"
                            :masks="masks"
                            :filter="filter"
                            :user="user"
                            :user-ids="userIds"
                            :office-ids="officeIds"
                            :contract-type-ids="contractTypeIds"
                            :fixed-date-range-identifier="fixedDateRangeIdentifier"
                            :field-labels="fieldLabels"
                            @stateUpdated="stateUpdated"
                        />
                    </div>
                    <div class="col-sm-3 float-right">
                        <i class="fa fa-fw text-left fa-btn fa-external-link pointer" title="Export" v-on:click="exportToExcel"></i>
                    </div>
                </td>
            </tr>
            <tr>
                <th class="bg-grey-lightest border-b border-grey-light"></th>
                <th v-for="column in availableColumns" class="pl-2 py-3 bg-grey-lightest border-b border-grey-light" style="width:9%">
                    <div class="column-resize">
                        <button class="font-bold uppercase text-xs text-grey-darkest hover:text-teal hover:no-underline"
                                :class="currentOrder.sortBy === column.property_name ? 'text-teal' : ''"
                                @click="sendOrderRequest(column)">
                            {{ getFieldLabel(fieldLabels, column.name.replace(/ /g, '-').toLowerCase()) }}
                            <i class="fa fa-xs fa-chevron-down ml-2"
                            v-if="currentOrder.property === column.property_name && currentOrder.direction === 'desc'"></i>
                            <i class="fa fa-xs fa-chevron-up ml-2"
                            v-if="currentOrder.property === column.property_name && currentOrder.direction === 'asc'"></i>
                        </button>
                    </div>
                </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(project, index) in followUps.projects" :key="index"
                class="hover:bg-grey-lighter cursor-pointer inline-update-bg-color"
                :class="[project.id == requiredFieldProjectId ? 'required-field-missing' : '']">
                <td v-if="availableColumns.length > 0" :class="Number(project.age) < 0 ? 'bg-green' : 'bg-red'" class="pl-2 py-2 border-b"></td>
                <td v-for="column in availableColumns" class="pl-2 py-2 border-b border-grey-light text-grey-darkest text-xs"
                        :class="[(column.property_name == 'sequential_team_id' || column.property_name == 'project_name' || column.property_name == 'project_address' || column.property_name == 'project_city' || column.property_name == 'project_state' || column.property_name == 'project_zip' || column.property_name == 'project_contact_name' || column.property_name == 'project_contact_email' || column.property_name == 'project_contact_phone' || column.property_name == 'project_contact_cell' || column.property_name == 'project_contact_fax' || column.property_name == 'company_contact_name' || column.property_name == 'company_contact_company_name' || column.property_name == 'company_contact_title' || column.property_name == 'company_contact_email' || column.property_name == 'company_contact_cell' || column.property_name == 'company_contact_followup' || column.property_name == 'company_contact_status') ? 'td-text-overflow' : '', (project.pin_project === 1) ? 'pin-project-highlighted' : '',(column.property_name === 'project_name' && project.pre_qualified) ? 'bg-qualified': '']">
                    <span @click="goToProject(project)" v-if="column.property_name !== 'base_bid' && column.property_name != 'contract_amount' && column.property_name != 'contract_date' && column.property_name != 'meeting_date' && column.property_name != 'login_date' && column.property_name != 'gross_margin' && column.property_name != 'labor_hours' && column.property_name != 'dead_date' && column.property_name != 'status' && column.property_name != 'marketing_status' && column.property_name !== 'pre_bid' && column.property_name != 'bid_date' && column.property_name != 'lead_from' && column.property_name != 'estimator' && column.property_name != 'account_manager' && column.property_name != 'take_off_person' && column.property_name != 'products_and_services' && column.property_name != 'client_profile' && column.property_name != 'contract_type_name' && column.property_name != 'office_name' && column.property_name != 'comment' && !column.is_custom_field"
                    :class="(column.property_name === 'project_name') ? 'fix-name-content' : ''" :title="project[column.property_name]">
                        {{ (column.property_name == 'age') ? ( project[column.property_name] < 0 ? '-' :  project[column.property_name]): ((column.property_name == 'project_contact_phone' || column.property_name == 'company_contact_cell' || column.property_name == 'project_contact_cell') && symbols.currency_name == 'Pounds') ? project[column.property_name].replace(/[^\d]/g, "") : project[column.property_name] }}
                    </span>
                    <!-- <span v-if="column.property_name === 'base_bid' || column.property_name === 'contract_amount' || column.property_name === 'contract_date' || column.property_name === 'login_date' || column.property_name === 'gross_margin' || column.property_name === 'labor_hours' || column.property_name === 'dead_date' || column.property_name === 'status' || column.property_name === 'marketing_status' || column.property_name === 'pre_bid' || column.property_name === 'bid_date' || column.property_name === 'lead_from' || column.property_name === 'estimator' || column.property_name === 'account_manager' || column.property_name === 'take_off_person' || column.property_name === 'products_and_services' || column.property_name === 'client_profile' || column.property_name === 'contract_type_name' || column.property_name === 'office_name' || column.is_custom_field">
                        <inline-update :project="project" :column="column" :masks="masks" :selects="selects" :requestFrom="'follow_up'"></inline-update>
                    </span> -->
                    <span
                        @click.stop="column.property_name === 'comment'"
                        v-if="column.property_name === 'comment'"
                        class="hover:bg-grey-lighter text-center">

                        <inline-comment :projectColumn="column" :projects="project" :users="users"></inline-comment>

                    </span>

                    <span @click.stop="column.property_name === 'pin'"
                                  v-if="column.property_name === 'pin'" class="hover:bg-grey-lighter text-center">

                        <pin-project :projectColumn="column" :projects="project" @fetchProjectData="fetchProjectData"  @updateLoader="updateLoader"></pin-project>
                    </span>

                    <!--Project Inline Update-->

                    <span @click.stop="column.property_name==='base_bid' || column.property_name==='contract_amount' || column.property_name === 'gross_margin' || column.property_name === 'labor_hours'" v-if="column.property_name==='base_bid' || column.property_name==='contract_amount' || column.property_name === 'gross_margin' || column.property_name === 'labor_hours'">
                        <currency-input
                            v-model="project[column.property_name]"
                            locale="us"
                            :currency="null"
                            v-on:change="setPayloadData(column.property_name, project[column.property_name], project)"
                            class="rounded p-1 text-grey-darkest text-xs focus:outline-none hover:bg-grey-lighter border-none w-full"
                            :class="[(project.id == requiredFieldProjectId) ? 'required-field-missing' : '', (project.pin_project === 1) ? 'pin-project-highlighted' : '']">
                        </currency-input>
                    </span>
                    <span @click.stop="column.property_name === 'login_date' || column.property_name === 'contract_date'|| column.property_name === 'dead_date'" v-if="column.property_name === 'login_date'  || column.property_name === 'contract_date'|| column.property_name === 'dead_date'">
                        <datepicker v-model="project[column.property_name]" :format="masks.date_mask"
                            :input-class="[(project.id == requiredFieldProjectId) ? 'required-field-missing' : '', (project.pin_project === 1) ? 'pin-project-highlighted' : '']"
                            @keypress.enter.prevent="closeCalendar()"
                            @input="setPayloadData(column.property_name, project[column.property_name], project, true)">
                        </datepicker>
                    </span>
                    <span @click.stop="column.property_name === 'meeting_date'" v-if="column.property_name === 'meeting_date'">
                          <span v-show="hasCalendarAccess == 0">
                              <datepicker v-model="project[column.property_name]" :format="masks.date_mask"
                                          :input-class="project.id == requiredFieldProjectId ? 'required-field-missing' : ''"
                                          @keypress.enter.prevent="closeCalendar()"
                                          @input="setPayloadData(column.property_name, project[column.property_name], project, true, false, true, project.company_contact_id)">
                              </datepicker>
                        </span>
                        <span v-show="hasCalendarAccess == 1">
                            <datetime type="datetime" name="date"  use12-hour
                                      v-model="project[column.property_name]"
                                      class="w-full"
                                      :format="masks.date_time_mask"
                                      :minute-step="15"
                                      :week-start="7"
                                      :input-class="project.id == requiredFieldProjectId ? 'required-field-missing' : ''"
                                      @input="setPayloadData(column.property_name, project[column.property_name], project, true, false, true, project.company_contact_id)">>
                            </datetime>
                        </span>
                    </span>
                    <span @click.stop="column.property_name==='status'" v-if="column.property_name==='status'">
                        <select v-model="project.sales_status_id"
                                :style="{'background-color':project.status_background_color, 'border' : project.status_border_color+' 1px solid'}"
                                @change="setPayloadData(column.property_name, $event.target.value, project)"
                                class="appearance-none p-1 border-none focus:outline-none rounded text-grey-darkest text-xs w-full"
                                :class="[(project.id == requiredFieldProjectId) ? 'required-field-missing' : '', (project.pin_project === 1) ? 'pin-project-highlighted' : '','sales_statuses_code_'+project.id]">
                            <option selected></option>
                            <option v-for="item in selects.sales_status" :value="item.id">{{ item.full_description }}</option>
                        </select>
                    </span>
                    <span @click.stop="column.property_name==='marketing_status'" v-if="column.property_name==='marketing_status'">
                        <select v-model="project.marketing_status_id"
                                @change="setPayloadData(column.property_name, $event.target.value, project)"
                                class="appearance-none p-1 border-none focus:outline-none rounded text-grey-darkest text-xs w-full"
                                :class="[(project.id == requiredFieldProjectId) ? 'required-field-missing' : '', (project.pin_project === 1) ? 'pin-project-highlighted' : '']">
                                <option selected></option>
                                <option v-for="item in selects.marketing_status" :value="item.id">{{ item.full_description }}</option>
                        </select>
                    </span>
                    <span @click.stop="column.property_name==='lead_from'" v-if="column.property_name==='lead_from'">
                        <select v-model="project.lead_from_id"
                                @change="setPayloadData(column.property_name, $event.target.value, project)"
                                class="appearance-none p-1 border-none focus:outline-none rounded text-grey-darkest text-xs w-full"
                                :class="[(project.id == requiredFieldProjectId) ? 'required-field-missing' : '', (project.pin_project === 1) ? 'pin-project-highlighted' : '']">
                                <option selected></option>
                                <option v-for="item in selects.lead_from" :value="item.id">{{ item.full_description }}</option>
                        </select>
                    </span>
                    <span @click.stop="column.property_name==='estimator'" v-if="column.property_name==='estimator'">
                        <select v-model="project.estimator_id"
                                @change="setPayloadData(column.property_name, $event.target.value, project)"
                                class="appearance-none p-1 border-none focus:outline-none rounded text-grey-darkest text-xs w-full"
                                :class="[(project.id == requiredFieldProjectId) ? 'required-field-missing' : '', (project.pin_project === 1) ? 'pin-project-highlighted' : '']">
                                <option selected></option>
                                <option v-for="item in selects.users" :value="item.id">{{ item.name }}</option>
                        </select>
                    </span>
                    <span @click.stop="column.property_name==='account_manager_name' || column.property_name==='account_manager'" v-if="column.property_name==='account_manager_name' || column.property_name==='account_manager'">
                        <select v-model="project.account_manager_id"
                                @change="setPayloadData(column.property_name, $event.target.value, project)"
                                class="appearance-none p-1 border-none focus:outline-none rounded text-grey-darkest text-xs w-full"
                                :class="[(project.id == requiredFieldProjectId) ? 'required-field-missing' : '', (project.pin_project === 1) ? 'pin-project-highlighted' : '']">
                                <option selected></option>
                                <option v-for="item in selects.users" :value="item.id">{{ item.name }}</option>
                        </select>
                    </span>
                    <span @click.stop="column.property_name==='take_off_person_name' || column.property_name==='take_off_person'" v-if="column.property_name==='take_off_person_name' || column.property_name==='take_off_person'">
                        <select v-model="project.take_off_person_id"
                                @change="setPayloadData(column.property_name, $event.target.value, project)"
                                class="appearance-none p-1 border-none focus:outline-none rounded text-grey-darkest text-xs w-full"
                                :class="[(project.id == requiredFieldProjectId) ? 'required-field-missing' : '', (project.pin_project === 1) ? 'pin-project-highlighted' : '']">
                                <option selected></option>
                                <option v-for="item in selects.users" :value="item.id">{{ item.name }}</option>
                        </select>
                    </span>
                    <span @click.stop="column.property_name==='products_and_services'" v-if="column.property_name==='products_and_services'">
                        <select v-model="project.products_and_services_id"
                                @change="setPayloadData(column.property_name, $event.target.value, project)"
                                class="appearance-none p-1 border-none focus:outline-none rounded text-grey-darkest text-xs w-full"
                                :class="[(project.id == requiredFieldProjectId) ? 'required-field-missing' : '', (project.pin_project === 1) ? 'pin-project-highlighted' : '']">
                                <option selected></option>
                                <option v-for="item in selects.products_and_services" :value="item.id">{{ item.full_description }}</option>
                        </select>
                    </span>
                    <span @click.stop="column.property_name==='client_profile'" v-if="column.property_name==='client_profile'">
                        <select v-model="project.client_profile_id"
                                @change="setPayloadData(column.property_name, $event.target.value, project)"
                                class="appearance-none p-1 border-none focus:outline-none rounded text-grey-darkest text-xs w-full"
                                :class="[(project.id == requiredFieldProjectId) ? 'required-field-missing' : '', (project.pin_project === 1) ? 'pin-project-highlighted' : '']">
                                <option selected></option>
                                <option v-for="item in selects.client_profile" :value="item.id">{{ item.full_description }}</option>
                        </select>
                    </span>
                    <span @click.stop="column.property_name==='contract_type_name'" v-if="column.property_name==='contract_type_name'">
                        <select v-model="project.contract_type_id"
                                @change="setPayloadData(column.property_name, $event.target.value, project)"
                                class="appearance-none p-1 border-none focus:outline-none rounded text-grey-darkest text-xs w-full"
                                :class="[(project.id == requiredFieldProjectId) ? 'required-field-missing' : '', (project.pin_project === 1) ? 'pin-project-highlighted' : '']">
                                <option selected></option>
                                <option v-for="item in selects.contract_type" :value="item.id">{{ item.full_description }}</option>
                        </select>
                    </span>
                    <span @click.stop="column.property_name==='office_name'" v-if="column.property_name==='office_name'">
                        <select v-model="project.office_id"
                                @change="setPayloadData(column.property_name, $event.target.value, project)"
                                class="appearance-none p-1 border-none focus:outline-none rounded text-grey-darkest text-xs w-full"
                                :class="[(project.id == requiredFieldProjectId) ? 'required-field-missing' : '', (project.pin_project === 1) ? 'pin-project-highlighted' : '']">
                                <option selected></option>
                                <option v-for="item in selects.office" :value="item.id">{{ item.full_description }}</option>
                        </select>
                    </span>
                    <span @click.stop="column.property_name==='pre_bid'" v-if="column.property_name==='pre_bid'">
                    <datepicker v-model="project[column.property_name]" :format="masks.date_mask"
                                :input-class="[(project.id == requiredFieldProjectId) ? 'required-field-missing' : '', (project.pin_project === 1) ? 'pin-project-highlighted' : '']"
                                @keypress.enter.prevent="closeCalendar()"
                                @input="setPayloadData(column.property_name, project[column.property_name], project, true)"></datepicker>
                    </span>
                    <span @click.stop="column.property_name==='bid_date'" v-if="column.property_name==='bid_date'">
                    <datepicker v-model="project[column.property_name]" :format="masks.date_mask"
                                :input-class="[(project.id == requiredFieldProjectId) ? 'required-field-missing' : '', (project.pin_project === 1) ? 'pin-project-highlighted' : '']"
                                @keypress.enter.prevent="closeCalendar()"
                                @input="setPayloadData(column.property_name, project[column.property_name], project, true)"></datepicker>
                    </span>
                    <span @click.stop="column.is_custom_field===true" v-if="column.is_custom_field===true && (column.custom_field_type === 'USER' || column.custom_field_type === 'DROPDOWN')">
                        <select :value="getCustomFieldValue(project.custom_field_data, column.custom_field_id)"
                                @change="setPayloadData(column.custom_field_id, $event.target.value, project, false, true)"
                                class="appearance-none p-1 border-none focus:outline-none rounded text-grey-darkest text-xs w-full"
                                :class="[(project.id == requiredFieldProjectId) ? 'required-field-missing' : '', (project.pin_project === 1) ? 'pin-project-highlighted' : '']">
                                <option selected></option>
                                <option v-for="item in column.custom_field_options" :value="item.id">{{ item.name }}</option>
                        </select>
                    </span>
                    <span @click.stop="column.is_custom_field===true" v-if="column.is_custom_field===true && column.custom_field_type === 'TEXT'">
                        <input :value="getCustomFieldValue(project.custom_field_data, column.custom_field_id)"
                            type="text"
                            @change="setPayloadData(column.custom_field_id, $event.target.value, project, false, true)"
                            class="appearance-none p-1 border-none focus:outline-none rounded text-grey-darkest text-xs w-full"
                            :class="[(project.id == requiredFieldProjectId) ? 'required-field-missing' : '', (project.pin_project === 1) ? 'pin-project-highlighted' : '']">
                    </span>
                    <span @click.stop="column.is_custom_field===true" v-if="column.is_custom_field===true && column.custom_field_type === 'DATE'">
                                <datepicker type="date"
                                          :value="getCustomFieldValue(project.custom_field_data, column.custom_field_id)"
                                          :use-utc="true"
                                          class="w-full"
                                          :format="masks.date_mask"
                                          :week-start="7"
                                          @input="setPayloadData(column.custom_field_id, $event, project, true, true)"
                                          :input-class="[(project.id == requiredFieldProjectId) ? 'required-field-missing' : '', (project['pin_project'] === 1) ? 'pin-project-highlighted' : '', 'appearance-none p-1 border-none focus:outline-none rounded text-grey-darkest text-xs w-full']">
                                </datepicker>
                            </span>
                    <!--Project Inline Update-->

                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import inlineUpdate from './inline-update';
import inlineComment from './inline-comment';
import Datepicker from 'vuejs-datepicker';
import pinProject from '../project/pin-project/pin-project';
export default {
    components: { inlineUpdate, inlineComment, Datepicker, pinProject },
    props: ['follow-ups', 'current-order', 'state', 'masks', 'filter', 'user', 'fixedDateRangeIdentifier', 'customFields', 'availableColumns', 'userIds', 'officeIds', 'contractTypeIds', 'symbols', 'customFieldTypeConstants', 'selects', 'users','fieldLabels','hasCalendarAccess'],

    data() {
        const stateCustomFields = this.customFields.map(customField => ({
            name: customField.label_value,
            checked: true,
            property_name: customField.name,
            is_custom_field: true,
            custom_field_id: customField.id,
            custom_field_type: this.customFieldTypeConstants[customField.type],
        }));
        let newState = {
            ...this.state,
            'Follow Up': [
                {
                    name: 'ID',
                    order: 'id',
                    customClass: '',
                    checked: true,
                    property_name: 'sequential_team_id',
                },
                {
                    name: 'Project Name',
                    order: 'project_name',
                    customClass: 'w-1/5',
                    checked: true,
                    property_name: 'project_name',
                },
                {
                    name: 'Due Date',
                    order: 'meeting_date',
                    customClass: '',
                    checked: true,
                    property_name: 'meeting_date',
                },
                {
                    name: 'Status',
                    order: 'status',
                    customClass: 'hidden xl:table-cell',
                    checked: true,
                    property_name: 'status',
                },
                {
                    name: 'Base Bid',
                    order: 'base_bid',
                    customClass: 'hidden lg:table-cell',
                    checked: true,
                    property_name: 'base_bid',
                },
                {
                    name: 'Age',
                    order: 'age',
                    customClass: 'hidden lg:table-cell',
                    checked: true,
                    property_name: 'age',
                },
                {
                    name: 'Address',
                    order: 'project_address',
                    customClass: '',
                    checked: true,
                    property_name: 'project_address',
                },
                {
                    name: 'City',
                    order: 'project_city',
                    customClass: '',
                    checked: true,
                    property_name: 'project_city',
                },
                {
                    name: 'State',
                    order: 'project_state',
                    customClass: '',
                    checked: true,
                    property_name: 'project_state',
                },
                {
                    name: 'Zip',
                    order: 'project_zip',
                    customClass: '',
                    checked: true,
                    property_name: 'project_zip',
                },
                {
                    name: 'Contract Amount',
                    order: 'contract_amount',
                    customClass: '',
                    checked: true,
                    property_name: 'contract_amount',
                },
                {
                    name: 'Contract Date',
                    order: 'contract_date',
                    customClass: '',
                    checked: true,
                    property_name: 'contract_date',
                },
                {
                    name: 'Login Date',
                    order: 'login_date',
                    customClass: '',
                    checked: true,
                    property_name: 'login_date',
                },
                {
                    name: 'Gross Margin',
                    order: 'gross_margin',
                    customClass: '',
                    checked: true,
                    property_name: 'gross_margin',
                },
                {
                    name: 'Labor Hours',
                    order: 'labor_hours',
                    customClass: '',
                    checked: true,
                    property_name: 'labor_hours',
                },
                {
                    name: 'Dead Date',
                    order: 'dead_date',
                    customClass: '',
                    checked: true,
                    property_name: 'dead_date',
                },
                {
                    name: 'Pre Bid',
                    order: 'pre_bid',
                    customClass: '',
                    checked: true,
                    property_name: 'pre_bid',
                },
                {
                    name: 'Bid Date',
                    order: 'bid_date',
                    customClass: '',
                    checked: true,
                    property_name: 'bid_date',
                },
                {
                    name: 'Marketing Status',
                    order: 'marketing_status',
                    customClass: '',
                    checked: true,
                    property_name: 'marketing_status',
                },
                {
                    name: 'Project Contact',
                    order: 'project_',
                    customClass: '',
                    checked: true,
                    property_name: 'project_contact_name',
                },
                {
                    name: 'Project Email',
                    order: '',
                    customClass: '',
                    checked: true,
                    property_name: 'project_contact_email',
                },
                {
                    name: 'Project Phone',
                    order: '',
                    customClass: '',
                    checked: true,
                    property_name: 'project_contact_phone',
                },
                {
                    name: 'Project Cell',
                    order: '',
                    customClass: '',
                    checked: true,
                    property_name: 'project_contact_cell',
                },
                {
                    name: 'Project Fax',
                    order: '',
                    customClass: '',
                    checked: true,
                    property_name: 'project_contact_fax',
                },
                {
                    name: 'Company Contact',
                    order: '',
                    customClass: '',
                    checked: true,
                    property_name: 'company_contact_name',
                },
                {
                    name: 'Company',
                    order: '',
                    customClass: '',
                    checked: true,
                    property_name: 'company_contact_company_name',
                },
                {
                    name: 'Contact Title',
                    order: '',
                    customClass: '',
                    checked: true,
                    property_name: 'company_contact_title',
                },
                {
                    name: 'Contact Email',
                    order: '',
                    customClass: '',
                    checked: true,
                    property_name: 'company_contact_email',
                },
                {
                    name: 'Contact Cell',
                    order: '',
                    customClass: '',
                    checked: true,
                    property_name: 'company_contact_cell',
                },
                {
                    name: 'Contact Follow Up',
                    order: '',
                    customClass: '',
                    checked: true,
                    property_name: 'company_contact_followup',
                },
                {
                    name: 'Contact Status',
                    order: '',
                    customClass: '',
                    checked: true,
                    property_name: 'company_contact_status',
                },
                {
                    name: 'Marketing Status',
                    order: '',
                    customClass: '',
                    checked: true,
                    property_name: 'marketing_status',
                },
                {
                    name: 'Lead From',
                    order: '',
                    customClass: '',
                    checked: true,
                    property_name: 'lead_from',
                },
                {
                    name: 'Client Profile',
                    order: '',
                    customClass: '',
                    checked: true,
                    property_name: 'client_profile',
                },
                {
                    name: 'Office Name',
                    order: '',
                    customClass: '',
                    checked: true,
                    property_name: 'office_name',
                },
                {
                    name: 'Contract Type',
                    order: '',
                    customClass: '',
                    checked: true,
                    property_name: 'contract_type_name',
                },
                // {
                //     name: 'Office',
                //     order: '',
                //     customClass: '',
                //     checked: true,
                //     property_name: 'office',
                // },
                {
                    name: 'Products & Services',
                    order: '',
                    customClass: '',
                    checked: true,
                    property_name: 'products_and_services',
                },
                {
                    name: 'Estimator',
                    order: '',
                    customClass: '',
                    checked: true,
                    property_name: 'estimator',
                },
                {
                    name: 'Account Manager',
                    order: '',
                    customClass: '',
                    checked: true,
                    property_name: 'account_manager',
                },
                {
                    name: 'Take Off Person',
                    order: '',
                    customClass: '',
                    checked: true,
                    property_name: 'take_off_person',
                },
                {
                    name: 'Comment',
                    order: '',
                    customClass: '',
                    checked: true,
                    property_name: 'comment',
                },
                {
                    name: 'Pin',
                    order: '',
                    customClass: '',
                    checked: true,
                    property_name: 'pin',
                },
                ...stateCustomFields,
            ]
        };


        if (this.state && this.state['Follow Up']) {
            const stateHash = this.state['Follow Up'].reduce(function (map, obj) {
                map[obj.name] = obj;
                return map;
            }, {});
            newState['Follow Up'] = Object.values(stateHash);

        } else {
            const baseStateHash = newState['Follow Up'].reduce(function (map, obj) {
                map[obj.name] = obj;
                return map;
            }, {});
            newState['Follow Up'] = Object.values(baseStateHash);
        }

        return {
            columns: newState,
            requiredFieldProjectId: null,
            payload: {
                inlineColumnType: null,
                inlineColumnValue: null,
                project: null
            },
            inline_update_loading:false,
            pin_project_loading: false,
        };
    },
    mounted() {

        Bus.$on('sendRequiredFieldProjectId', data => {
            this.requiredFieldProjectId = data;

            let self = this;
            setTimeout(function() {
                self.requiredFieldProjectId = null;
                Bus.$emit('sendRequiredFieldProjectIdRes', self.requiredFieldProjectId);
            }, 5000);
        });
    },
    methods: {
        goToProject(project) {
            if (project.id === '-') {
                window.location = route('company.show', {company: project.company_id});
            } else {
                window.location = route('project.edit', {project: project.id, dashboard: 1});
            }
        },
        exportToExcel() {
            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 2000
            });

            if(this.availableColumns.length > 0) {
                let newWindow = window.open(route('dashboard.excel', {
                    "start-date": this.filter.start,
                    "end-date": this.filter.end,
                    "user": (this.userIds && this.userIds.length > 0) ?JSON.stringify(this.userIds) : JSON.stringify([]),
                    "office": (this.officeIds && this.officeIds.length > 0) ? JSON.stringify(this.officeIds) : null,
                    "contract-type": (this.contractTypeIds && this.contractTypeIds.length > 0) ? JSON.stringify(this.contractTypeIds) : null,
                    "behavior-name": 'Follow Up',
                    "columns": this.columns['Follow Up'].filter((column) => {
                        if(column.checked){
                            return column
                        }
                    }).map(column => ({
                        name: column.name,
                        property_name: column.property_name
                    })),
                }), this.name, 'location=0,width=860,height=740,toolbar=0,menubar=0,location=0');
                if (window.focus) {newWindow.focus()}
            }else{
                Toast.fire({
                    type: "error",
                    title: 'Select some columns to export'
                });
            }

        },
        order(property) {
            this.$emit('order', property);
        },
        stateUpdated(updatedState) {
            this.$emit('updateParentState', updatedState);
        },
        setPayloadData(column, value, project, isDate=false, isCustomField=false, isFollowUp=false, company_contact_id=null) {
            if (!value){
                return;
            }
            let self = this;
            let propertyColumn = self.getRenameColumn(column);
            let propertyValue = value;
            if (propertyColumn === "sales_status_id"){
                this.adjustTextColor(project,propertyValue);
            }
            if(isDate && !isCustomField) {
                if(isFollowUp && this.hasCalendarAccess) {
                    propertyValue = moment(value).utc().format('YYYY-MM-DD HH:mm:ss');
                    if (moment(project.meeting_timestamp).utc().format('YYYY-MM-DD HH:mm:ss') == propertyValue){
                        return;
                    }
                }else {
                    propertyValue = moment(value).utc().format('YYYY-MM-DD');
                    if (moment(project.meeting_timestamp).utc().format('YYYY-MM-DD') == propertyValue){
                        return;
                    }
                }
            }
            if(isDate && isCustomField) {
                propertyValue = moment(value).format('YYYY-MM-DD');
            }

            self.payload = {
                inlineColumnType: propertyColumn,
                inlineColumnValue: propertyValue,
                project: project
            }

            if(isCustomField) {

                self.$set(self.payload, 'isCustomField', isCustomField);
            }

            if(isFollowUp) {

                self.$set(self.payload, 'isFollowUp', isFollowUp);
                self.$set(self.payload, 'companyContactId', company_contact_id);
            }

            if (isDate && isCustomField){
                _.each(project.custom_field_data, function(customField) {
                    if(customField.id == propertyColumn && value && value != "" && moment(customField.value).format('MM/DD/yyyy') !== moment(value).format('MM/DD/yyyy')) {
                        self.sendPostRequest();
                    }
                });
            }else {
                self.sendPostRequest();
            }

        },
        sendPostRequest() {
            this.inline_update_loading = true;
            axios.post(route('inline-record-update'), this.payload).then(response => {
                if(response) {

                    let self = this;
                    setTimeout(function(){
                        self.projectUpdatedData();
                    },3000);
                }
            }).catch(error => {
                if(error) {

                    this.inline_update_loading = false;
                    let self = this;
                    setTimeout(function() {
                        self.projectUpdatedData(true);
                    },3000);
                }
                this.requiredFieldProjectId = this.payload.project.id;

                Bus.$emit('sendRequiredFieldProjectId', this.requiredFieldProjectId);

                this.getToast(5000).fire({
                    type: 'error',
                    title: "Required field must be updated in order to update this field.\nPlease drill into the project to update."
                });
            })
        },
        getRenameColumn(colunmHeading) {
            let columnVal = '';
            switch (colunmHeading) {
                case 'marketing_status':
                    columnVal = 'marketing_status_id';
                    break
                case 'status':
                    columnVal = 'sales_status_id';
                    break
                case 'lead_from':
                    columnVal = 'lead_from_id';
                    break
                case 'estimator_name':
                case 'estimator':
                    columnVal = 'estimator_id';
                    break
                case 'account_manager_name':
                case 'account_manager':
                    columnVal = 'account_manager_id';
                    break
                case 'take_off_person_name':
                case 'take_off_person':
                    columnVal = 'take_off_person_id';
                    break
                case 'products_and_services':
                    columnVal = 'products_and_services_id';
                    break
                case 'client_profile':
                    columnVal = 'client_profile_id';
                    break
                case 'contract_type':
                case 'contract_type_name':
                    columnVal = 'contract_type_id';
                    break
                case 'office':
                case 'office_name':
                    columnVal = 'office_id';
                    break
                default:
                    columnVal = colunmHeading;
                    break
            }
            return columnVal;
        },
        getCustomFieldValue(customFieldsData, fieldId) {

            if(customFieldsData) {

                for (var i = 0; i < customFieldsData.length; i++) {

                    if (customFieldsData[i].id === fieldId) {

                        return customFieldsData[i].value;
                    }
                }
            }
        },
        projectUpdatedData(isError=false) {
            axios.post(route('project-updated-data'), this.payload).then(response => {
                let self = this;
                let counter = 0;
                this.followUps.projects = _.map(this.followUps.projects, function(project) {
                    if(project.id == self.payload.project.id) {
                        project.contract_amount = response.data.contract_amount;
                        project.base_bid = response.data.base_bid;
                        project.labor_hours = response.data.labor_hours;
                        project.gross_margin = response.data.gross_margin;
                        project.login_date = response.data.project.login_date;
                        project.contract_date = response.data.project.contract_date;
                        project.dead_date = response.data.project.dead_date;
                        project.sales_status_id = response.data.project.sales_status_id;
                        project.marketing_status_id = response.data.project.marketing_status_id;
                        project.lead_from_id = response.data.project.lead_from_id;
                        project.estimator_id = response.data.project.estimator_id;
                        project.account_manager_id = response.data.project.account_manager_id;
                        project.take_off_person_id = response.data.project.take_off_person_id;
                        project.products_and_services_id = response.data.project.products_and_services_id;
                        project.client_profile_id = response.data.project.client_profile_id;
                        project.contract_type_id = response.data.project.contract_type_id;
                        project.office_id = response.data.project.office_id;
                        project.pre_bid = response.data.pre_bid;
                        project.bid_date = response.data.bid_date;
                        project.custom_field_data = response.data.custom_field_data;
                        if(isError && counter < 1) {
                            if(self.payload.isFollowUp) {
                                if(self.payload.companyContactId && self.payload.companyContactId == project.company_contact_id) {
                                    project.meeting_date = response.data.contact_meeting_date;
                                    counter++;
                                }
                                else if(!self.payload.companyContactId && project.company_contact_id == null) {
                                    project.meeting_date = response.data.meeting_date;
                                    counter++;
                                }
                            }
                        }
                    }
                    return project;
                });
                this.inline_update_loading = false;
            });
        },

        fetchProjectData() {
            this.$emit("fetchUpdatedProjects");
        },

        updateLoader(value) {
            this.pin_project_loading = value;
        },
        sendOrderRequest(column) {
            let property = column.property_name;
            if(column.is_custom_field) {
                property = this.convertToSlug(column.property_name);
            }
            this.order(property);
        },
        convertToSlug(name) {
            return name.toLowerCase()
                    .replace(/ /g, '-')
                    .replace(/[^\w-]+/g, '');
        },

        adjustTextColor(project,status_id) {
            let element, bgColor, broderColor;
            element = 'sales_statuses_code_'+project.id;
            if (status_id === null || status_id === ''){
                return;
            }
            let saleStatus = this.mapSaleStatus(status_id);
            bgColor = this.increaseBrightness(saleStatus.color, 70);
            broderColor = this.darkColor(saleStatus.color, -20);

            $('.'+element).css("background-color",bgColor);
            $('.'+element).css("border",broderColor+' 1px solid');

        },
        mapSaleStatus(status_id){
            return _.find(this.selects.sales_status, function(obj) { return obj.id == status_id });
        },

        increaseBrightness(hex, percent){
            hex = hex.replace(/^\s*#|\s*$/g, '');

            if(hex.length == 3){
                hex = hex.replace(/(.)/g, '$1$1');
            }

            var r = parseInt(hex.substr(0, 2), 16),
                g = parseInt(hex.substr(2, 2), 16),
                b = parseInt(hex.substr(4, 2), 16);

            return '#' +
                ((0|(1<<8) + r + (256 - r) * percent / 100).toString(16)).substr(1) +
                ((0|(1<<8) + g + (256 - g) * percent / 100).toString(16)).substr(1) +
                ((0|(1<<8) + b + (256 - b) * percent / 100).toString(16)).substr(1);
        },

        darkColor(color, percent) {

            var R = parseInt(color.substring(1,3),16);
            var G = parseInt(color.substring(3,5),16);
            var B = parseInt(color.substring(5,7),16);

            R = parseInt(R * (100 + percent) / 100);
            G = parseInt(G * (100 + percent) / 100);
            B = parseInt(B * (100 + percent) / 100);

            R = (R<255)?R:255;
            G = (G<255)?G:255;
            B = (B<255)?B:255;

            var RR = ((R.toString(16).length==1)?"0"+R.toString(16):R.toString(16));
            var GG = ((G.toString(16).length==1)?"0"+G.toString(16):G.toString(16));
            var BB = ((B.toString(16).length==1)?"0"+B.toString(16):B.toString(16));

            return "#"+RR+GG+BB;
        }
    }
}
</script>

<style>
.pin-project-highlighted {
    background-color: #fff5eb;
}
.bg-qualified{
    background-color: #00ff8f !important;
}
.remove-overflow-x{
    overflow-x: unset !important;
}
#followupProjects .fix-name-content{
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 10vw !important;
    display: block;
}
.inline_update_loading_class {
    position: absolute !important;
    top: 10% !important;
    left: 50% !important;
    z-index: 999 !important;
}
#followupProjects {
    border-collapse: collapse;
    border-spacing: 0px;
    overflow: scroll;
}
#followupProjects th {
    padding: 0;
    margin: 0px;
}
#followupProjects th div.column-resize {
    resize: horizontal;
    overflow: auto;
    min-width: 90%;
    margin: 0px;
    padding: 0px;
    display:block;
    border: 0;
}
#followupProjects td.td-text-overflow {
    overflow: hidden;
}
.pin-black {
    font-size: 16px !important;
}
.pin-red {
    font-size: 16px !important;
    color: red !important;;
}
@media only screen
and (min-device-width: 768px)
and (max-device-width: 1024px)
and (-webkit-min-device-pixel-ratio: 1) {
    td > span{
        white-space: nowrap;
        width : auto !important;
        display: block;
    }
    select{
        white-space: nowrap;
        width : auto !important;
        display: block;
    }
    #followupProjects .fix-name-content{
        white-space: nowrap;
        width : auto !important;
        display: block;
    }
}

@media only screen
and (min-device-width: 768px)
and (max-device-width: 1024px)
and (orientation: portrait)
and (-webkit-min-device-pixel-ratio: 1) {
    td > span{
        white-space: nowrap;
        width : auto !important;
        display: block;
    }
    select{
        white-space: nowrap;
        width : auto !important;
        display: block;
    }
    #followupProjects .fix-name-content{
        white-space: nowrap;
        width : auto !important;
        display: block;
    }
}
.bg-qualified {
    background-color: #00ff8f;
}
</style>
